import React, { useState, useMemo } from 'react';
import { RelatedItem, RelatedList, RelatedFilter } from '../common';
import { sortAsc } from '@helpers/numHelpers';
import { RelatedItem as RelatedItemType, RelatedItemTag } from '@layouts/Related/Related.types';

interface RelatedContainerProps {
  styleType: string;
  content: RelatedItemType[];
  blockContent?: string;
  I18n: Record<string, string>;
  contentType: string;
}

export const RelatedContainer = ({
  styleType,
  content,
  blockContent,
  I18n,
  contentType,
}: RelatedContainerProps) => {
  const [filterTag, setFilterTag] = useState<RelatedItemTag>({ id: 0, name: 'All' });

  const updateFilterTag = (aFilterTag: RelatedItemTag) => {
    if (filterTag.id != aFilterTag.id) {
      setFilterTag(aFilterTag);
    }
  };

  const tags = useMemo(() => {
    let filters: RelatedItemTag[] = [];
    let tags: RelatedItemType[] = [];

    if (content) {
      tags = content.filter((item) => item.Tags);
    }
    
    /* Iterate all tags */
      tags.forEach(function (items) {
        items.Tags?.forEach(function (item) {
          item && filters.push(item);
        });
      });
    
    
    if (filters.length > 0) {
      const stringFilters = filters.map((item) => JSON.stringify(item));
      const uniqueStringFilters = new Set(stringFilters);
      filters = [];
      uniqueStringFilters.forEach((item) => filters.push(JSON.parse(item)));
      filters.sort(sortAsc);
    }
    return filters;
  }, [content]);

  return !(content || blockContent) ? null : (
    <div className='l-section l-section-100'>
      {blockContent && (
        <div className='l-page' dangerouslySetInnerHTML={{ __html: blockContent }} />
      )}

      <RelatedFilter
        tags={tags}
        i18n={I18n}
        isBound={true}
        className={'is-related'}
        onTagClick={updateFilterTag}
        contentType={contentType}
      />

      <RelatedList styleType={styleType} items={content} i18n={I18n} filterTag={filterTag} />
    </div>
  );
};
